<template>
  <div class="warningCotent" @click="isFieldSettingsVisible = false">
    <DeviceWarningsCount
      v-if="currentWarningContentType.routeName === 'DeviceAllWarnings'"
      :toggleComponent="toggleComponent"
    />

    <div v-else class="warning_table">
      <header>
        <h2>{{ title }}</h2>
        <a-space>
          <a-button @click="goBack">{{ $t("buttons.goBack") }}</a-button>
          <a-button type="primary" @click="renderWarningTable(1)">{{ $t("buttons.search") }}</a-button>
          <a-button v-if="isExportable" :loading="isExporting" type="primary" @click="exportWarnings">{{ $t("buttons.export") }}</a-button>
        </a-space>
      </header>

      <div class="content">
        <div class="dropdown-container fo">
          <a style="margin-left: 15px;" @click.stop="toggleFieldSettingsVisible">
            {{ $t("warning.setFields") }} <a-icon type="down" />
          </a>
          <ul
            v-show="isFieldSettingsVisible"
            role="menu"
            tabindex="0"
            class="
              ant-dropdown-menu
              ant-dropdown-menu-vertical
              ant-dropdown-menu-root
              ant-dropdown-menu-light
              ant-dropdown-content
              dropdown
              fo"
            >
              <draggable v-model="warningTableUnsortableColumns" disabled>
                <li
                  v-for="(w, i) in warningTableUnsortableColumns"
                  role="menuitem"
                  class="ant-dropdown-menu-item fo disabled"
                  :key="w.dataIndex"
                  @click.stop
                >
                  <div style="display: flex; align-items: center;">
                    <svg @click.stop="" t="1763360109842" class="pre_icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8165" width="22" height="22"><path d="M344 132c38.66 0 70 31.34 70 70s-31.34 70-70 70-70-31.34-70-70 31.34-70 70-70z m70 380c0-38.66-31.34-70-70-70s-70 31.34-70 70 31.34 70 70 70 70-31.34 70-70z m336 0c0-38.66-31.34-70-70-70s-70 31.34-70 70 31.34 70 70 70 70-31.34 70-70zM344 752c38.66 0 70 31.34 70 70s-31.34 70-70 70-70-31.34-70-70 31.34-70 70-70z m406 70c0-38.66-31.34-70-70-70s-70 31.34-70 70 31.34 70 70 70 70-31.34 70-70z m0-620c0-38.66-31.34-70-70-70s-70 31.34-70 70 31.34 70 70 70 70-31.34 70-70z" fill="#323338" p-id="8166"></path></svg>
                    <span style="text-align: left; margin: 0 20px;">{{ $t(w.i18n) }}</span>
                  </div>
                  <div class="aft_icons" @click.stop="">
                    <svg @click.stop="backToColumnsAndHide(w, i)" t="1763360271703" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3543" width="22" height="22"><path d="M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3-7.7 16.2-7.7 35.2 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766z" p-id="3544" fill="rgba(0, 0, 0, 0.65)"></path><path d="M508 336c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176z m0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" p-id="3545" fill="rgba(0, 0, 0, 0.65)"></path></svg>
                    <svg @click.stop="backToColumns(w, i)" style="margin-left: 3px;" t="1763360488674" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9172" width="22" height="22"><path d="M706.081047 78.192364c2.699736 0 4.899522 0 9.399082 4.39957 3.999609 4.0996 4.39957 6.399375 4.39957 9.399083 0 3.099697-0.299971 5.299482-4.49956 9.599062-0.999902 1.099893-1.999805 1.899814-2.999707 2.499756-43.995704 30.197051-70.193145 79.592227-70.193146 132.187091v2.099795c0 123.787911 42.795821 244.576116 120.488234 340.166781 0.399961 0.499951 0.699932 0.899912 1.099893 1.399863 17.09833 21.497901 27.597305 44.395664 31.696904 69.393223h-566.944634c4.0996-24.997559 14.598574-47.895323 31.596914-69.293233 0.19998-0.299971 0.399961-0.599941 0.699932-0.799922 77.992384-96.290597 120.988185-217.278781 120.988185-340.766722v-2.299775c0-52.594864-26.297432-101.99004-70.293136-132.187091-0.999902-0.699932-2.099795-1.599844-3.199687-2.699737-3.999609-3.999609-4.29958-6.299385-4.29958-9.299091 0-3.099697 0.299971-5.299482 4.39957-9.499073 3.999609-3.999609 6.299385-4.29958 9.299092-4.29958h388.362074m0-63.993751H317.718973c-21.09794 0-39.396153 7.799238-54.694659 23.097745-15.298506 15.498486-22.997754 33.596719-22.997754 54.694659s7.799238 39.396153 23.097744 54.694658c3.899619 3.799629 7.899229 7.199297 12.098819 10.099014 26.297432 18.098233 42.49585 47.495362 42.49585 79.492237v2.299775C317.718973 347.966019 279.922664 453.955668 211.029392 538.947368c-0.299971 0.399961-0.599941 0.799922-0.999903 1.199883-31.796895 39.896104-47.595352 84.691729-47.595352 134.386877 0 10.498975 3.799629 19.598086 11.498877 27.297334 7.599258 7.699248 16.79836 11.498877 27.297335 11.498877h245.076066l46.095499 294.371253c1.999805 10.898936 8.49917 16.298408 19.398106 16.298408h0.599941c4.799531 0 8.999121-1.599844 12.398789-4.999512 3.499658-3.299678 5.699443-7.599258 6.399375-12.398789l31.096963-293.17137h260.374573c10.498975 0 19.598086-3.799629 27.297334-11.498877 7.699248-7.599258 11.498877-16.79836 11.498877-27.297334 0-49.895127-15.898447-94.690753-47.695342-134.586857-0.499951-0.599941-0.999902-1.299873-1.499853-1.899814-68.893272-84.691729-106.18963-190.681379-106.18963-299.770726v-2.099795c0-31.896885 16.098428-61.394004 42.39586-79.392247 4.29958-2.899717 8.29919-6.299385 12.198808-10.298994 15.398496-15.498486 23.097744-33.596719 23.097745-54.694659s-7.799238-39.296162-23.097745-54.694658c-15.398496-15.298506-33.496729-22.997754-54.594668-22.997755z" p-id="9173" fill="rgba(0, 0, 0, 0.65)"></path></svg>
                  </div>
                </li>
              </draggable>
              <a-divider v-show="warningTableUnsortableColumns.length" style="margin: 0;" />
              <draggable
                v-model="warningTableColumns"
                group="columns"
                class="draggble"
                @end="handleDragEnd"
              >
                <li
                  v-for="(w, i) in warningTableColumns"
                  role="menuitem"
                  class="ant-dropdown-menu-item fo"
                  :key="w.dataIndex"
                  @click.stop=""
                >
                  <div style="display: flex; align-items: center;">
                    <svg @click.stop="" t="1763360109842" class="pre_icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8165" width="22" height="22"><path d="M344 132c38.66 0 70 31.34 70 70s-31.34 70-70 70-70-31.34-70-70 31.34-70 70-70z m70 380c0-38.66-31.34-70-70-70s-70 31.34-70 70 31.34 70 70 70 70-31.34 70-70z m336 0c0-38.66-31.34-70-70-70s-70 31.34-70 70 31.34 70 70 70 70-31.34 70-70zM344 752c38.66 0 70 31.34 70 70s-31.34 70-70 70-70-31.34-70-70 31.34-70 70-70z m406 70c0-38.66-31.34-70-70-70s-70 31.34-70 70 31.34 70 70 70 70-31.34 70-70z m0-620c0-38.66-31.34-70-70-70s-70 31.34-70 70 31.34 70 70 70 70-31.34 70-70z" fill="#323338" p-id="8166"></path></svg>
                    <span @click.stop="" style="text-align: left; margin: 0 20px;">{{ $t(w.i18n) }}</span>
                  </div>
                  <div class="aft_icons" @click.stop="">
                    <svg @click.stop="toggleFieldHide(w)" v-if="!w.hide" t="1763360271703" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3543" width="22" height="22"><path d="M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3-7.7 16.2-7.7 35.2 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766z" p-id="3544" fill="rgba(0, 0, 0, 0.65)"></path><path d="M508 336c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176z m0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" p-id="3545" fill="rgba(0, 0, 0, 0.65)"></path></svg>
                    <svg @click.stop="toggleFieldHide(w)" v-else t="1763359974697" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6669" width="22" height="22"><path d="M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5z m-63.57-320.64L836 122.88a8 8 0 0 0-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 0 0 0 11.31L155.17 889a8 8 0 0 0 11.31 0l712.15-712.12a8 8 0 0 0 0-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 0 0-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512z m246.7 0a112.11 112.11 0 0 1 146.2-106.69L401.31 546.2A112 112 0 0 1 396 512z" p-id="6670" fill="rgba(0, 0, 0, 0.65)"></path><path d="M508 624c-3.46 0-6.87-0.16-10.25-0.47l-52.82 52.82a176.09 176.09 0 0 0 227.42-227.42l-52.82 52.82c0.31 3.38 0.47 6.79 0.47 10.25a111.94 111.94 0 0 1-112 112z" p-id="6671" fill="rgba(0, 0, 0, 0.65)"></path></svg>
                    <svg @click.stop="toggleFixed('warningTableColumns', 'warningTableUnsortableColumns', i)" style="margin-left: 3px;" t="1763360488674" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9172" width="22" height="22"><path d="M706.081047 78.192364c2.699736 0 4.899522 0 9.399082 4.39957 3.999609 4.0996 4.39957 6.399375 4.39957 9.399083 0 3.099697-0.299971 5.299482-4.49956 9.599062-0.999902 1.099893-1.999805 1.899814-2.999707 2.499756-43.995704 30.197051-70.193145 79.592227-70.193146 132.187091v2.099795c0 123.787911 42.795821 244.576116 120.488234 340.166781 0.399961 0.499951 0.699932 0.899912 1.099893 1.399863 17.09833 21.497901 27.597305 44.395664 31.696904 69.393223h-566.944634c4.0996-24.997559 14.598574-47.895323 31.596914-69.293233 0.19998-0.299971 0.399961-0.599941 0.699932-0.799922 77.992384-96.290597 120.988185-217.278781 120.988185-340.766722v-2.299775c0-52.594864-26.297432-101.99004-70.293136-132.187091-0.999902-0.699932-2.099795-1.599844-3.199687-2.699737-3.999609-3.999609-4.29958-6.299385-4.29958-9.299091 0-3.099697 0.299971-5.299482 4.39957-9.499073 3.999609-3.999609 6.299385-4.29958 9.299092-4.29958h388.362074m0-63.993751H317.718973c-21.09794 0-39.396153 7.799238-54.694659 23.097745-15.298506 15.498486-22.997754 33.596719-22.997754 54.694659s7.799238 39.396153 23.097744 54.694658c3.899619 3.799629 7.899229 7.199297 12.098819 10.099014 26.297432 18.098233 42.49585 47.495362 42.49585 79.492237v2.299775C317.718973 347.966019 279.922664 453.955668 211.029392 538.947368c-0.299971 0.399961-0.599941 0.799922-0.999903 1.199883-31.796895 39.896104-47.595352 84.691729-47.595352 134.386877 0 10.498975 3.799629 19.598086 11.498877 27.297334 7.599258 7.699248 16.79836 11.498877 27.297335 11.498877h245.076066l46.095499 294.371253c1.999805 10.898936 8.49917 16.298408 19.398106 16.298408h0.599941c4.799531 0 8.999121-1.599844 12.398789-4.999512 3.499658-3.299678 5.699443-7.599258 6.399375-12.398789l31.096963-293.17137h260.374573c10.498975 0 19.598086-3.799629 27.297334-11.498877 7.699248-7.599258 11.498877-16.79836 11.498877-27.297334 0-49.895127-15.898447-94.690753-47.695342-134.586857-0.499951-0.599941-0.999902-1.299873-1.499853-1.899814-68.893272-84.691729-106.18963-190.681379-106.18963-299.770726v-2.099795c0-31.896885 16.098428-61.394004 42.39586-79.392247 4.29958-2.899717 8.29919-6.299385 12.198808-10.298994 15.398496-15.498486 23.097744-33.596719 23.097745-54.694659s-7.799238-39.296162-23.097745-54.694658c-15.398496-15.298506-33.496729-22.997754-54.594668-22.997755z" p-id="9173" fill="rgba(0, 0, 0, 0.65)"></path></svg>
                  </div>
                </li>
              </draggable>
            </ul>
        </div>
        <el-table
          v-loading="isWarningTableLoading"
          style="border-top: 1px solid rgb(232, 232, 232); margin-top: 15px;"
          :key="tableKey"
          :data="warnings"
          :cell-style="warningTableRowCellStyle"
          @row-click="handleWarningTableRowClick"
        >
          <el-table-column
            v-for="u in warningTableUnsortableColumns"
            :key="u.dataIndex"
            :prop="u.dataIndex"
            :label="$t(`${u.i18n}`)"
            :width="u.width"
            fixed="left"
          >
            <template #header>
              <div class="tableHeader">
                {{ $t(`${u.i18n}`) }}
  
                <a-input
                  v-if="u.searchType === 'input'"
                  v-model="warningTableQueryParams[u.dataIndex]"
                  @keyup.enter="renderWarningTable(1)"
                />
  
                <a-select
                  v-if="u.searchType === 'select'"
                  v-model="warningTableFilterParams[u.dataIndex]"
                  :dropdownClassName="u.dropdownClass"
                  @change="renderWarningTable(1)"
                >
                  <a-select-option value="">{{ $t("common.all") }}</a-select-option>
                  <a-select-option
                    v-for="(v, k) in warningTableSelectOptions[u.selectOptionsField]"
                    :key="k"
                  >
                    {{ v }}
                  </a-select-option>
                </a-select>
  
                <div
                  v-if="u.searchType === 'multipies'"
                  style="display: flex"
                >
                  <a-select
                    v-model="warningTableMultipieFilterParams[u.dataIndex].req"
                    style="width: 50%"
                  >
                    <a-select-option value="">{{ $t("common.all") }}</a-select-option>
                    <a-select-option
                      v-for="(v, k) in warningTableSelectOptions[u.selectOptionsField]"
                      :key="k"
                    >
                      {{ v }}
                    </a-select-option>
                  </a-select>
                  <a-input-number
                    v-model="warningTableMultipieFilterParams[u.dataIndex].value"
                    @keyup.enter="renderWarningTable(1)"
                  />
                </div>
  
                <a-input-number
                  v-if="u.searchType === 'leaveTime'"
                  v-model="warningTableFilterParams[u.dataIndex].value"
                  @keyup.enter="renderWarningTable(1)"
                />
              </div>
            </template>
            <template slot-scope="scope">
              <template v-if="u.linked">
                <a-button
                  v-if="authorities[u.linkAuthoritation]"
                  style="padding: 0; user-select: auto;"
                  type="link"
                  :loading="scope.row[u.loadingField]" 
                  @click="warningTableButtonsClickEvents[u.routeFunctionName](scope.row)"
                >
                  <text-highlight
                    v-if="u.searchType === 'input'"
                    :queries="warningTableHighlightInfo[u.dataIndex]"
                  >
                    {{ scope.row[u.reachField] }}
                  </text-highlight>
                  <span v-else-if="u.searchType === 'select'">
                    {{ warningTableSelectOptions[c.selectOptionsField][scope.row[u.reachField]] }}
                  </span>
                  <span v-else>{{ scope.row[u.reachField] }}</span>
                </a-button>
                <span v-else>
                  <text-highlight
                    v-if="u.searchType === 'input'"
                    :queries="warningTableHighlightInfo[u.dataIndex]"
                  >
                    {{ scope.row[u.reachField] }}
                  </text-highlight>
                  <span v-else-if="u.searchType === 'select'">
                    {{ warningTableSelectOptions[c.selectOptionsField][scope.row[u.reachField]] }}
                  </span>
                  <span v-else>{{ scope.row[u.reachField] }}</span>
                </span>
              </template>
              <template v-else>
                <text-highlight
                  v-if="u.searchType === 'input'"
                  :queries="warningTableHighlightInfo[u.dataIndex]"
                >
                  {{ scope.row[u.reachField] }}
                </text-highlight>
                <span v-else-if="u.searchType === 'select'">
                  {{ warningTableSelectOptions[u.selectOptionsField][scope.row[u.reachField]] }}
                </span>
                <span v-else>{{ scope.row[u.reachField] }}</span>
              </template>
            </template>
          </el-table-column>
          <template v-for="c in warningTableColumns">
            <el-table-column
              v-if="!c.hide"
              :key="c.dataIndex"
              :prop="c.dataIndex"
              :label="$t(`${c.i18n}`)"
              :width="c.width"
              :fixed="c.fixed"
            >
              <template #header>
                <div class="tableHeader">
                  {{ $t(`${c.i18n}`) }}
                  <a-input
                    v-if="c.searchType === 'input'"
                    v-model="warningTableQueryParams[c.dataIndex]"
                    @keyup.enter="renderWarningTable(1)"
                  />
  
                  <a-select
                    v-if="c.searchType === 'select'"
                    v-model="warningTableFilterParams[c.dataIndex]"
                    :dropdownClassName="c.dropdownClass"
                    @change="renderWarningTable(1)"
                  >
                    <a-select-option value="">{{ $t("common.all") }}</a-select-option>
                    <a-select-option
                      v-for="(v, k) in warningTableSelectOptions[c.selectOptionsField]"
                      :key="k"
                    >
                      {{ v }}
                    </a-select-option>
                  </a-select>
  
                  <div
                    v-if="c.searchType === 'multipies'"
                    style="display: flex;"
                  >
                    <a-select
                      v-model="warningTableMultipieFilterParams[c.dataIndex].req"
                      style="width: 50%;"
                      @change="handleWarningTableMultipieFilterParamsChange(c.dataIndex)"
                    >
                      <a-select-option value="">{{ $t("common.all") }}</a-select-option>
                      <a-select-option
                        v-for="(v, k) in warningTableSelectOptions[c.selectOptionsField]"
                        :key="k"
                      >
                        {{ v }}
                      </a-select-option>
                    </a-select>
                    <a-input-number
                      v-model="warningTableMultipieFilterParams[c.dataIndex].value"
                      @keyup.enter="handleWarningTableMultipieFilterParamsChange(c.dataIndex)"
                    />
                  </div>
  
                  <a-input-number
                    v-if="c.searchType === 'leaveTime'"
                    v-model="warningTableFilterParams[c.dataIndex].value"
                    @keyup.enter="renderWarningTable(1)"
                  />
                </div>
              </template>
              <template slot-scope="scope">
                <template v-if="c.linked">
                  <a-button
                    v-if="authorities[c.linkAuthoritation]"
                    style="padding: 0; user-select: auto;"
                    type="link"
                    :loading="scope.row[c.loadingField]"
                    @click="warningTableButtonsClickEvents[c.routeFunctionName](scope.row)"
                  >
                    <text-highlight
                      v-if="c.searchType === 'input'"
                      :queries="warningTableHighlightInfo[c.dataIndex]"
                    >
                      {{ scope.row[c.reachField] }}
                    </text-highlight>
                    <span v-else-if="c.searchType === 'select'">
                      {{ warningTableSelectOptions[c.selectOptionsField][scope.row[c.reachField]] }}
                    </span>
                    <span v-else>{{ scope.row[c.reachField] }}</span>
                  </a-button>
                  <span v-else>
                    <text-highlight
                      v-if="c.searchType === 'input'"
                      :queries="warningTableHighlightInfo[c.dataIndex]"
                    >
                      {{ scope.row[c.reachField] }}
                    </text-highlight>
                    <span v-else-if="c.searchType === 'select'">
                      {{ warningTableSelectOptions[c.selectOptionsField][scope.row[c.reachField]] }}
                    </span>
                    <span v-else>{{ scope.row[c.reachField] }}</span>
                  </span>
                </template>
                <template v-else>
                  <text-highlight
                    v-if="c.searchType === 'input'"
                    :queries="warningTableHighlightInfo[c.dataIndex]"
                  >
                    {{ scope.row[c.reachField] }}
                  </text-highlight>
                  <span v-else-if="c.searchType === 'select'">
                    {{ warningTableSelectOptions[c.selectOptionsField][scope.row[c.reachField]] }}
                  </span>
                  <span v-else>{{ scope.row[c.reachField] }}</span>
                </template>
              </template>
            </el-table-column>
          </template>
          <template v-if="warningTableOperationColumnWidth">
            <el-table-column
              fixed="right"
              :width="warningTableOperationColumnWidth"
            >
              <template #header>
                <div class="tableHeader" style="display: flex;">
                  {{ $t("common.operation") }}
                </div>
              </template>
              <template slot-scope="scope">
                <a-button
                  type="primary"
                  size="small"
                  @click.stop="showWarningRemindModal(scope.row)"
                >
                  {{ $t("warning.otherWarnings") }}
                </a-button>
                <a-button
                  style="margin-left: 10px"
                  type="primary"
                  size="small"
                  v-if="authorities.createWarningOrder"
                  v-show="scope.row.warningStatus === 'WARNING'"
                  @click.stop="showWarningOrderModal(scope.row)"
                >
                  {{ $t("warning.addOrder") }}
                </a-button>
                <a-button
                  style="margin-left: 10px"
                  type="primary"
                  size="small"
                  v-if="authorities.updateWarningOrder"
                  v-show="scope.row.warningStatus !== 'WARNING'"
                  @click.stop="showWarningOrderModal(scope.row, true)"
                >
                  {{ $t("warningOrder.orderInfo") }}
                </a-button>
                <a-button
                  style="margin-left: 10px"
                  type="primary"
                  size="small"
                  @click.stop="showWarningInfoDiaglog(scope.row)"
                >
                  {{ $t("warning.check") }}
                </a-button>
                <a-button
                  v-if="authorities.ableTohistory"
                  style="margin-left: 10px;"
                  type="primary"
                  size="small"
                  @click.stop="goToHistory(scope.row)"
                >
                  {{ $t("device.history") }}
                </a-button>
                <a-button
                  v-if="authorities.deletable"
                  style="margin-left: 10px;"
                  type="primary"
                  size="small"
                  @click.stop="showConfirmToDeleteWarning(scope.row)"
                >
                  {{ $t("buttons.delete") }}
                </a-button>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <a-pagination
          style="float: right; margin-top: 20px;"
          size="small"
          hideOnSinglePage
          :current="warningPagination.current"
          :pageSize="warningPagination.pageSize"
          :total="warningPagination.total"
          @change="renderWarningTable"
        />
        <div style="height: 50px;"></div>
      </div>

      <!-- 其它预警对话框 -->
      <a-modal v-model="isWarningRemindModalVisible" :width="1300">
        <WarningRemind :device="selectedDevice" :showDetailMethod="showWarningDetail" />
      </a-modal>

      <!-- 预警工单对话框 -->
      <WarningOrderModal
        :visible="isWarningOrderModalVisible"
        :warningTypes="warningMenus"
        :info="orderInfo"
        :closeModal="closeWarningOrderModal"
        :loading="isWarningOrderModalLoading"
        :changLoading="changeWarningOrderModalLoading"
        :refresh="renderWarningTable"
      />

      <!-- 查看预警对话框 -->
      <a-modal
        v-model="isWarningInfoModalVisible"
        :width="1500"
        :title="title"
        :confirmLoading="isWarningInfoModalLoading"
        :afterClose="clearWarningInfo"
        :okText="$t('buttons.save')"
        @ok="submitWarningInfo"
      >
        <a-descriptions>
          <a-descriptions-item :label="$t('runningData.machineCode')" :span="1">
            {{ deviceCodeForWarningInfoDiaglog }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('customer.company')" :span="2">
            {{ compnayForWarningInfoDiaglog }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('history.machineType')" :span="1">
            {{ deviceModelForWarningInfoDiaglog }}
          </a-descriptions-item>
          <a-descriptions-item :span="1">
            <el-date-picker
              v-model="ignoreDate"
              :picker-options="pickerOptions"
            />
            <span style="margin-left: 10px">
              {{ $t('warning.ignoreInfo') }}
            </span>
            <a style="margin-left: 15px;" @click="ignoreForever">{{ $t('warning.ignoreForever') }}</a>
          </a-descriptions-item>
          <a-descriptions-item :label="$t('device.warningTag')" :span="1">
            <a-select style="width: 200px" v-model="warningTag" dropdownClassName="warningTagOption">
              <a-select-option
                v-for="(v, k) in formWarningTags"
                :key="k"
              >
                {{ v }}
              </a-select-option>
            </a-select>
          </a-descriptions-item>
        </a-descriptions>
        <a-card
          :border="false"
          :tab-list="warningInfoModalCardTabList"
          :active-tab-key="activeWarningInfoModalCardTab"
          @tabChange="handleWarningInfoModalCardTabChange"
        >
          <template v-if="activeWarningInfoModalCardTab === 'history'">
            <!-- 预警历史 -->
            <header class="history_header">
              <a-form-model
                layout="inline"
                :label-col="{ span: 7 }"
                :wrapper-col="{ span: 17 }"
              >
                <a-form-model-item :label="$t('maintain.startTime')">
                  <a-date-picker v-model="warningHistoryStartTime" />
                </a-form-model-item>
                <a-form-model-item :label="$t('maintain.endTime')">
                  <a-date-picker v-model="warningHistoryEndTime" />
                </a-form-model-item>
              </a-form-model>
              <a-button type="primary" @click="renderWarningHistoryTable">{{ $t("buttons.search") }}</a-button>
            </header>
            <el-table
              v-loading="isWarningHistoryTableLoading"
              style="margin-top: 15px;"
              :max-height="360"
              :header-cell-style="{
                backgroundColor: '#fafafa',
                color: 'rgba(0, 0, 0, 0.85)',
                fontWeight: 500,
                textAlign: 'left'
              }"
              :data="warningHistories"
            >
              <el-table-column
                v-for="w in warningHistoryTableColumns"
                :key="w.dataIndex"
                :label="$t(`${w.i18n}`)"
                :prop="w.reachField"
              />
            </el-table>
          </template>

          <template v-if="activeWarningInfoModalCardTab === 'service'">
            <!-- 服务档案 -->
            <a-button type="primary" @click="showServiceModal()">{{ $t("buttons.add") }}</a-button>
            <el-table
              stripe
              style="width: 100%; margin-top: 10px;"
              v-loading="isServiceTableLoading"
              :data="serviceList"
              :header-cell-style="{ backgroundColor: '#fafafa' }"
            >
              <el-table-column prop="orderNum" label="订单编号" width="160">
                <template #header>
                  <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                    {{ $t("orders.code") }}
                  </div>
                  <a-input
                    v-model.trim="serviceTableQueryParams.orderNum"
                    allow-clear
                    @keyup.enter="renderServiceTable(1)"
                  />
                </template>
                <template slot-scope="scope">
                  <text-highlight :queries="serviceTableHighlightInfo.orderNum">
                    {{ scope.row.orderNum }}
                  </text-highlight>
                </template>
              </el-table-column>
              <el-table-column prop="equipmentName" label="设备名称" width="200">
                <template #header>
                  <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                    {{ $t("common.deviceName") }}
                  </div>
                  <a-input
                    v-model.trim="serviceTableQueryParams.equipmentName"
                    allow-clear
                    @keyup.enter="renderServiceTable(1)"
                  />
                </template>
                <template slot-scope="scope">
                  <text-highlight :queries="serviceTableHighlightInfo.equipmentName">
                    {{ scope.row.equipmentName }}
                  </text-highlight>
                </template>
              </el-table-column>
              <el-table-column prop="equipmentModel" label="规格型号" width="100">
                <template #header>
                  <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                    {{ $t("common.model") }}
                  </div>
                  <a-input
                    v-model.trim="serviceTableQueryParams.equipmentModel"
                    allow-clear
                    @keyup.enter="renderServiceTable(1)"
                  />
                </template>
                <template slot-scope="scope">
                  <text-highlight :queries="serviceTableHighlightInfo.equipmentModel">
                    {{ scope.row.equipmentModel }}
                  </text-highlight>
                </template>
              </el-table-column>
              <el-table-column prop="serviceType" label="服务类型" width="110">
                <template #header>
                  <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                    {{ $t("saleDocument.serviceType") }}
                  </div>
                  <a-select
                    v-model="serviceTableQueryParams.serviceType"
                    style="width: 100%"
                    @change="renderServiceTable(1)"
                  >
                    <a-select-option value="">{{ $t("common.all") }}</a-select-option>
                    <a-select-option
                      v-for="(value, key) in orderStateMap"
                      :key="key"
                    >
                      {{ value }}
                    </a-select-option>
                  </a-select>
                </template>
                <template slot-scope="scope">
                  {{ orderStateMap[scope.row.serviceType] }}
                </template>
              </el-table-column>
              <el-table-column prop="customer" label="客户名称" width="220">
                <template #header>
                  <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                    {{ $t("common.customerName") }}
                  </div>
                  <a-input
                    v-model.trim="serviceTableQueryParams.customer"
                    allow-clear
                    @keyup.enter="renderServiceTable(1)"
                  />
                </template>
                <template slot-scope="scope">
                  <text-highlight :queries="serviceTableHighlightInfo.customer">
                    {{ scope.row.customer }}
                  </text-highlight>
                </template>
              </el-table-column>
              <el-table-column prop="updateman" label="修改人" width="130">
                <template #header>
                  <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                    {{ $t("saleDocument.updateman") }}
                  </div>
                  <a-input
                    v-model.trim="serviceTableQueryParams.updateman"
                    allow-clear
                    @keyup.enter="renderServiceTable(1)"
                  />
                </template>
                <template slot-scope="scope">
                  <text-highlight :queries="serviceTableHighlightInfo.updateman">
                    {{ scope.row.updateman }}
                  </text-highlight>
                </template>
              </el-table-column>
              <el-table-column prop="serviceMan" label="服务员" width="130">
                <template #header>
                  <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                    {{ $t("common.serviceMen") }}
                  </div>
                  <a-input
                    v-model.trim="serviceTableQueryParams.serviceman"
                    allow-clear
                    @keyup.enter="renderServiceTable(1)"
                  />
                </template>
                <template slot-scope="scope">
                  <text-highlight :queries="serviceTableHighlightInfo.serviceman">
                    {{ scope.row.serviceman }}
                  </text-highlight>
                </template>
              </el-table-column>
              <el-table-column prop="equipmentCode" label="整机编号" width="160">
                <template #header>
                  <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                    {{ $t("device.code") }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="serviceTime" label="服务时间" width="200">
                <template #header>
                  <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                    {{ $t("saleDocument.serviceTime") }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="updateTime" label="修改时间" width="200">
                <template #header>
                  <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                    {{ $t("saleDocument.updateTime") }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="createman" label="创建人" width="120">
                <template #header>
                  <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                    {{ $t("saleDocument.createman") }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间" width="200">
                <template #header>
                  <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                    {{ $t("saleDocument.createTime") }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120" fixed="right">
                <template #header>
                  <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
                    {{ $t("common.operation") }}
                  </div>
                </template>
                <template slot-scope="scope">
                  <a-button
                    style="padding-left: 0; margin-left: -3px"
                    type="link"
                    @click="showServiceModal(scope.row)"
                  >
                    {{ $t('buttons.edit') }}
                  </a-button>
                  <a-popconfirm
                    :title="$t('messages.ctrd')"
                    :ok-text="$t('common.okText')"
                    :cancel-text="$t('common.cancelText')"
                    @confirm="removeService(scope.row)"
                  >
                    <a-button
                      style="padding-left: 0"
                      type="link"
                      :loading="scope.row.loading"
                    >
                      {{ $t("buttons.delete") }}
                    </a-button>
                  </a-popconfirm>
                </template>
              </el-table-column>
            </el-table>
            <a-pagination
              style="float: right; margin-top: 20px;"
              hideOnSinglePage
              :current="servicePagination.current"
              :pageSize="servicePagination.pageSize"
              :total="servicePagination.total"
              @change="renderServiceTable"
            />
            <div style="height: 50px;"></div>
            <!-- 服务档案对话框 -->
            <ServiceModal
              :visible="isServiceModalVisible"
              :title="serviceModalTitle"
              :typeMap="orderStateMap"
              :record="selectedService"
              :closeModal="closeServiceModal"
            />
          </template>

          <template v-if="activeWarningInfoModalCardTab === 'note'">
            <!-- 预警记录 -->
            <a-button type="primary" @click="showWarningRecordModal()">
              {{ $t("buttons.add") }}
            </a-button>
            <a-table
              style="margin-top: 10px;"
              :columns="warningRecordTableColumns"
              :data-source="warningRecords"
              :row-key="setRowKey"
              :loading="isWarningRecordTableLoading"
            >
              <template v-slot:content="text, record">
                <a-input v-if="record.edit" v-model="record.content" />
                <span v-else>{{ text }}</span>
              </template>
              <template v-slot:operation="_, record">
                <a-button
                  type="link"
                  size="small"
                  style="padding-left: 0"
                  @click="showWarningRecordModal(record)"
                >
                  {{ record.edit ? $t("buttons.save") : $t("buttons.edit") }}
                </a-button>
                <a-popconfirm
                  :title="$t('messages.ctrd')"
                  :ok-text="$t('common.okText')"
                  :cancel-text="$t('common.cancelText')"
                  @confirm="removeWarningRecord(record)"
                >
                  <a href="#">{{ $t("buttons.delete") }}</a>
                </a-popconfirm>
              </template>
              <template v-slot:images="_, record">
                <div class="upload-demo" data-v-1ab1ffd8="">
                  <ul class="el-upload-list el-upload-list--text">
                    <li
                      v-for="(img, i) in record.images"
                      tabindex="0"
                      style="float: left;width: 64px; height: 64px; position: relative"
                      :key="i"
                      @mouseover="handleWarningRecordTableMouseover(record, i)"
                      @mouseleave="handleWarningRecordTableMouseleave(record, i)"
                    >
                      <div v-show="record.images[i].isMaskShow" class="mask"
                        style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0, 0, 0, .3); z-index: 100; display: flex; justify-content: center; align-items: center; cursor: pointer;">
                        <a-icon type="eye" style="color: #ccc; font-size: 20px; z-index: 100;" @click="previewImg(i, record.images)" />
                      </div>
                      <img :src="img.path" style="width: 100%; height: 100%; object-fit: cover; cursor: pointer" />
                    </li>
                  </ul>
                </div>
              </template>
            </a-table>

            <!-- 预警记录对话框 -->
            <a-modal
              v-model="isWarningRecordModalVisible"
              :title="$t('warning.note')"
              :afterClose="clearWarningRecordForm"
              :confirm-loading="isWarningRecordModalLoading"
              @ok="submitWarningRecord"
            >
              <a-form-model>
                <a-form-model-item :label="$t('warning.record')">
                  <a-input v-model="warningRecordForm.content" />
                </a-form-model-item>
                <a-form-model-item :label="$t('common.picture')">
                  <div class="upload">
                    <button
                      aria-disabled="false"
                      type="button"
                      class="el-button el-button" 
                      :key="fileList.length"
                    >
                      <span
                        class="el-icon-upload"
                        style="padding: 8px 15px;"
                        @click="showFileModal"
                      >
                        <i></i>
                        &nbsp;&nbsp;
                        {{ $t("buttons.uploadPic") }}
                      </span>
                    </button>
                    <input
                      multiple
                      ref="InputFileDOm"
                      class="file"
                      type="file"
                      accept=".mp4,.jpg,.jpeg,.png,.webm"
                      :limit="6"
                      @change="hadnleFileChange"
                    />
                    <div class="upload-demo" data-v-1ab1ffd8="">
                      <ul class="el-upload-list el-upload-list--text" :key="fileList.length">
                        <li
                          v-for="(_, index) in fileList"
                          tabindex="0"
                          style="float: left;width: 100px; height: 100px; position: relative"
                          :key="srcList[index].path"
                          @mouseover="srcList[index].isMaskShow = true; $forceUpdate()"
                          @mouseleave="srcList[index].isMaskShow = false; $forceUpdate()"
                        >
                          <div v-show="srcList[index].isMaskShow" class="mask"
                            style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0, 0, 0, .3); z-index: 100; display: flex; justify-content: center; align-items: center; cursor: pointer;">
                            <a-icon type="eye" style="color: #ccc; font-size: 20px; margin-right: 10px" @click="previewImg(index)" />
                            <a-icon type="delete" style="color: #ccc; font-size: 20px" @click="rF(index)" />
                          </div>
                          <img :src="srcList[index].path" style="width: 100%; height: 100%; object-fit: cover; cursor: pointer" />
                        </li>
                      </ul>
                    </div>
                  </div>
                </a-form-model-item>
              </a-form-model>
            </a-modal>
          </template>
        </a-card>
      </a-modal>
    </div>
  </div>
</template>

<script>
import DeviceWarningsCount from "./DeviceWarningsCount"
import draggable from "vuedraggable"
import TextHighlight from "vue-text-highlight"
import WarningRemind from "@/views/EquipmentManager/EquipmentList/View/WarningRemind"
import WarningOrderModal from "@/components/common/WarningOrderModal"
import ServiceModal from "@/components/common/ServiceModal"
import warningOptions from "../data"
import moment from "moment"
import debounce from "@/components/function/debounce"

import {
  getFields,
  getWarningList,
  exportWarningList,
  postFields,
  getWarningHistory,
  deleteWarningRecordNote,
  updateWarningRecord,
  addWarningRecord,
  getWarningInfo,
  addWarningNote,
  updateWarningNote,
  addWarningIgnore,
  updateWarningIgnore,
  deleteWarningIgnore,
  deleteErrorRecord
} from "@/api/warning"
import { getDict } from "@/api/dict"
import {
  searchDeviceList,
  updateDevice
} from "@/api/device"
import {
  getList,
  removeS
} from "@/api/service"

export default {
  components: {
    DeviceWarningsCount,
    draggable,
    TextHighlight,
    WarningRemind,
    WarningOrderModal,
    ServiceModal,
    TextHighlight
  },
  props: {
    currentWarningContentType: {
      type: Object,
      required: true
    },
    toggleComponent: {
      type: Function,
      default: () => {}
    },
    warningMenus: {
      type: Array,
      default: []
    },
    toggleCurrentWarningType: {
      type: Function,
      default: () => {}
    },
    setCurrentWarningContentType: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      title: "",
      renderKey: false,
      pickerOptions: {},
      isExportable: false,
      isExporting: false,
      /* 预警字段配置 */
      isFieldSettingsVisible: false,
      /* 预警表格 */
      tableKey: false,
      isWarningTableLoading: false,
      warningTableUnsortableColumns: [],
      warningTableColumns: [],
      warnings: [],
      warningTableQueryParams: {},
      warningTableFilterParams: {},
      warningTableMultipieFilterParams: {},
      warningTableSelectOptions: {
        warningStatuses: {},
        warningTags: {},
        judgeTypes: {
          eq: '=',
          ne: '≠',
          gt: '>',
          ge: '≥',
          lt: '<',
          le: '≤'
        }
      },
      warningTableButtonsClickEvents: {
        goToDevice: this.goToDevice,
        goToCustomer: this.goToCustomer
      },
      warningTableHighlightInfo: {},
      authorities: {
        deviceUpdatable: false,
        customerUpdatable: false,
        createWarningOrder: false,
        updateWarningOrder: false,
        ableTohistory: false,
        deletable: false
      },
      warningTableOperationColumnWidth: 0,
      warningPagination: {
        current: 1,
        pageSize: 16,
        total: 0
      },
      /* 其它预警对话框 */
      isWarningRemindModalVisible: false,
      selectedDevice: {},
      /* 预警工单对话框 */
      isWarningOrderModalVisible: false,
      isWarningOrderModalLoading: false,
      orderInfo: {},
      /* 查看预警对话框 */
      isWarningInfoModalVisible: false,
      isWarningInfoModalLoading: false,
      deviceCodeForWarningInfoDiaglog: "",
      compnayForWarningInfoDiaglog: "",
      deviceModelForWarningInfoDiaglog: "",
      ignoreDate: null,
      warningTag: null,
      formWarningTags: [],
      warningInfoModalCardTabList: [],
      activeWarningInfoModalCardTab: "",
      /* 查看预警对话框_预警历史 */
      isWarningHistoryTableLoading: false,
      warningHistoryStartTime: null,
      warningHistoryEndTime: null,
      warningHistoryTableColumns: [],
      warningHistories: [],
      /* 查看预警对话框_服务档案 */
      isServiceTableLoading: false,
      serviceList: [],
      serviceTableQueryParams: {
        orderNum: "",
        serviceType: "",
        equipmentCode: "",
        equipmentName: "",
        equipmentModel: "",
        customer: "",
        servicehours: "",
        serviceContent: "",
        serviceman: "",
        updateman: ""
      },
      serviceTableHighlightInfo: {
        orderNum: "",
        serviceType: "",
        equipmentCode: "",
        equipmentName: "",
        equipmentModel: "",
        customer: "",
        servicehours: "",
        serviceContent: "",
        serviceman: "",
        updateman: ""
      },
      orderStateMap: {},
      /* 服务档案对话框 */
      isServiceModalVisible: false,
      serviceModalTitle: "",
      selectedService: {},
      servicePagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      /* 查看预警对话框_预警记录 */
      warningRecordTableColumns: [
        {
          title: () => this.$t("warning.index"),
          dataIndex: "index",
          key: "index"
        },
        {
          title: () => this.$t("warning.content"),
          dataIndex: "content",
          key: "content",
          width: 310,
          scopedSlots: {
            customRender: "content"
          }
        },
        {
          title: () => this.$t("common.updatedAt"),
          dataIndex: "updatedAt",
          key: "updatedAt"
        },
        {
          title: () => this.$t("common.picture"),
          dataIndex: "attachments",
          key: "attachments",
          scopedSlots: {
            customRender: "images"
          },
          width: 241
        },
        {
          title: () => this.$t("common.operation"),
          dataIndex: "operation",
          key: "operation",
          scopedSlots: {
            customRender: "operation"
          }
        }
      ],
      warningRecords: [],
      isWarningRecordTableLoading: false,
      /* 预警记录对话框 */
      isWarningRecordModalVisible: false,
      isWarningRecordModalLoading: false,
      warningRecordForm: {
        content: "",
        deviceId: ""
      },
      fileList: [],
      srcList: []
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang() {
      this.translate()
    }
  },
  created() {
    this.warningTableOperationColumnWidth_zh = 160
    const deviceAuthorities = this.getAuthorities("/equipment/list")

    let d
    for (let i = 0; i < deviceAuthorities.length; i++) {
      d = deviceAuthorities[i]
      if (d.code === "device:manage:device:update") {
        this.authorities.deviceUpdatable = true
      }
      if (d.code === "device:manage:device:history:query") {
        this.authorities.ableTohistory = true
        this.warningTableOperationColumnWidth_zh += 80
      }
    }

    const customerAuthorities = this.getAuthorities("/customer")
    let c
    for (let i = 0; i < customerAuthorities.length; i++) {
      c = customerAuthorities[i]
      if (c.code === "customer:update") {
        this.authorities.customerUpdatable = true
        break
      }
    }

    const warningOrderAuthorities = this.getAuthorities("/warning/order")
    let w, flag = false
    for (let i = 0; i < warningOrderAuthorities.length; i++) {
      w = warningOrderAuthorities[i]
      if (w.code === "warning:workOrder:create") {
        this.authorities.createWarningOrder = true
        flag = true
      }

      if (w.code === "warning:workOrder:update") {
        this.authorities.updateWarningOrder = true
        flag = true
      }
    }
    if (flag) {
      this.warningTableOperationColumnWidth_zh += 80
    }

    if (this.currentWarningContentType.routeName === "ERROR") {
      const a = this.getAuthorities("/warning/error")
      if (a.find(t => t.code === "warning:device:delete:error")) {
        this.authorities.deletable = true
        this.warningTableOperationColumnWidth_zh += 60
      }
    }

    this.warningTableOperationColumnWidth_en = this.warningTableOperationColumnWidth_zh + 50
    this.warningTableOperationColumnWidth = this[`warningTableOperationColumnWidth_${this.lang}`]

    const warningAuthorities = this.getAuthorities(this.currentWarningContentType.route)
    this.isExportable = !!warningAuthorities.find(w => w.code.includes("export"))
  },
  mounted() {
    if (this.currentWarningContentType.routeName !== "DeviceAllWarnings") {
      this.render()
    }
  },
  methods: {
    translate() {
      const lang = this.lang === "en" ? "en-US" : "zh-CN"
      this.title = this.currentWarningContentType[lang]

      this.pickerOptions = {
        shortcuts: [
          {
            text: this.$t('time.week'),
            onClick(picker) {
              const now = new Date()
              now.setDate(now.getDate() + 7)
              picker.$emit('pick', now)
            }
          },
          {
            text: this.$t('time.halfMonth'),
            onClick(picker) {
              const now = new Date()
              now.setDate(now.getDate() + 15)
              picker.$emit('pick', now)
            }
          },
          {
            text: this.$t('time.month'),
            onClick(picker) {
              const now = new Date()
              now.setMonth(now.getMonth() + 1)
              picker.$emit('pick', now)
            }
          },
          {
            text: this.$t('time.threeMonths'),
            onClick(picker) {
              const now = new Date()
              now.setMonth(now.getMonth() + 3)
              picker.$emit('pick', now)
            }
          },
          {
            text: this.$t('time.halfYear'),
            onClick(picker) {
              const now = new Date()
              now.setMonth(now.getMonth() + 6)
              picker.$emit('pick', now)
            }
          },
          {
            text: this.$t('time.year'),
            onClick(picker) {
              const now = new Date()
              now.setFullYear(now.getFullYear() + 1)
              picker.$emit('pick', now)
            }
          }
        ]
      }

      const tabList = [], serviceAuthorities = this.getAuthorities("/service")
      tabList.push({
        key: "history",
        tab: this.$t("warningHistory.title")
      })
      if (serviceAuthorities.find(a => a.code === "after:sale:document:query")) {
        tabList.push({
          key: "service",
          tab: this.$t("saleDocument.tab")
        })
      }
      tabList.push({
        key: "note",
        tab: this.$t("warning.note")
      })

      this.warningInfoModalCardTabList = tabList
    },
    getPopupContainer(triggerNode) {
      return triggerNode.parentNode
    },
    async render() {
      this.translate()
      await this.setWarningTableOptions()
      await this.setWarningTableSelectOptions()
      this.renderWarningTable()
      this.setServiceTableSelectOptions()
    },
    /* 预警表格渲染 */
    async setWarningTableOptions() {
      const key = this.currentWarningContentType.routeName

      this.warningTableColumns = []
      this.warningTableUnsortableColumns = []

      const columns = await this.requestFields()
      const totalColumns = warningOptions.commonTableFields.concat([...(warningOptions.privateColumns[key] || [])])
      
      let res = [], fixedRes = []
      if (columns?.length) {
        let c, col, h
        for (let i = 0; i < columns.length; i++) {
          c = columns[i]
          h = c.split("-")
          col = totalColumns.find(column => column.dataIndex === h[0])
          if (col) {
            if (h?.[1] === "hide") {
              col.hide = true
              res.push(col)
            } else if (h?.[1] === "fixed") {
              col.hide = false
              fixedRes.push(col)
            } else {
              col.hide = false
              res.push(col)
            }
          }
        }
      } else {
        res = totalColumns
      }

      const multipieFilterParams = {}
      for (let key in warningOptions.commonMultipieFilterParams) {
        multipieFilterParams[key] = { ...warningOptions.commonMultipieFilterParams[key] }
      }

      this.warningTableColumns = res
      this.warningTableUnsortableColumns = fixedRes
      this.warningTableMultipieFilterParams = multipieFilterParams
      this.warningTableHighlightInfo = { ...warningOptions.commonHighlightInfo }
      this.warningTableQueryParams = { ...warningOptions.commonQueryParams }
      this.warningTableFilterParams = { ...warningOptions.commonFilterParams, ...(warningOptions.privateFilterParams[key] || {})}
      if (key === "MAINTAIN") {
        this.warningTableFilterParams.leaveDays.value = 30
      }
      const dc = localStorage.getItem("deviceCode")
      if (dc) {
        this.warningTableQueryParams["device.code"] = dc
        localStorage.removeItem("deviceCode")
        localStorage.removeItem("targetWarningType")
      }
    },
    async setWarningTableSelectOptions() {
      const lang = this.lang === "zh" ? "zh-CN" : "en-US"

      let temp = {}, v

      const warningStatuses = await this.requestWarningStatuses(lang)
      for (let i = 0; i < warningStatuses.length; i++) {
        v = warningStatuses[i]
        temp[v.value] = v.text
      }
      this.warningTableSelectOptions.warningStatuses = temp

      temp = {}

      const tags = await this.requestWarningTags(lang)
      for (let i = 0; i < tags.length; i++) {
        v = tags[i]
        if (v.value) {
          temp[v.value] = v.text
        }
      }
      this.warningTableSelectOptions.warningTags = {
        EMPTY: " ",
        ...temp
      }
      this.formWarningTags = {
        "": " ",
        ...temp
      }
      this.$nextTick(() => {
        this.warningTableFilterParams["device.tag"] = "EMPTY"
      })
    },
    warningTableRowCellStyle({ rowIndex }) {
      if (rowIndex % 2) {
        return "background-color: #fafafa;"
      } else {
        return "background-color: #fff;"
      }
    },
    handleWarningTableRowClick(r, c, e) {
      const o = document.querySelector(".table_highlight")
      if (o) {
        o.classList.remove("table_highlight")
      }
      let node = e.target
      while (node.nodeName !== "TR") {
        node = node.parentNode
      }
      node.classList.add("table_highlight")
    },
    setWarningTableSearchParams() {
      const params = {
        query: [],
        filter: [],
        sort: []
      }

      if (this.currentWarningContentType.routeName === "MAINTAIN") {
        params.sort = [
          {
            field: "leaveDays",
            value: "ASC"
          },
          {
            field: "leaveHours",
            value: "ASC"
          },
          {
            field: "createdAt",
            value: "DESC"
          }
        ]
      } else {
        params.sort = [
          {
            field: "createdAt",
            value: "DESC"
          }
        ]
      }

      let value
      for (let q in this.warningTableQueryParams) {
        value = this.warningTableQueryParams[q] = this.warningTableQueryParams[q].trim()
        if (q === "device.code") {
          value = value.split("-").join("")
        }
        if (value) {
          params.query.push({
            field: q,
            value
          })
        }
      }

      for (let f in this.warningTableFilterParams) {
        value = this.warningTableFilterParams[f]
        if (value instanceof Object) {
          if (value.value || value.value === 0) {
            params.filter.push({
              field: f,
              req: value.req,
              value: value.value
            })
          }
        } else {
          if (value) {
            if (f === "device.tag" && value === "EMPTY") {
              params.query.push({
                type: "or",
                properties: [
                  {
                    field: "device.tag",
                    value: "null"
                  },
                  {
                    field: "device.tag",
                    value: "EMPTY"
                  }
                ]
              })
            } else {
              params.filter.push({
                field: f,
                value
              })
            }
          }
        }
      }

      for (let m in this.warningTableMultipieFilterParams) {
        value = this.warningTableMultipieFilterParams[m]
        if (value.value && value.req) {
          params.filter.push({
            field: m,
            req: value.req,
            value: value.value
          })
        }
      }

      if (params.filter.length) {
        params.filter.push({
          field: "mode",
          value: "and"
        })
      }

      return params
    },
    async renderWarningTable(p = this.warningPagination.current) {
      this.warningPagination.current = p
      this.isWarningTableLoading = true

      const { records, total } = await this.requestWarningList()

      let oMap = {}, nMap = {}, rMap = {}, m
      this.warnings = records.map(r => {
        r.customerCompany = r.customer?.company || ""
        if (r.device) {
          r.deviceCode = r.device.code
          r.deviceTag = r.device.tag
          r.deviceModel = r.device.model
          r.devicePower = r.device.power
          r.deviceLastMaintainTime = r.device.lastMaintainTime
        }
        oMap = {}
        nMap = {}
        rMap = {}
        m = null
        if (r.salesmen) {
          for (let i = 0; i < r.salesmen.length; i++) {
            m = r.salesmen[i]
            oMap[m.organizationName] = m.organizationName
            nMap[m.realName] = m.realName
            rMap[m.roleName] = m.roleName
          }
          r.organizationNamesOfSalesMen = Object.values(oMap).join("，")
          r.namesOfSalesMen = Object.values(nMap).join("，")
          r.roleNamesOfSalesMen = Object.values(rMap).join("，")
        }
        oMap = {}
        nMap = {}
        rMap = {}
        m = null
        if (r.serviceMans) {
          for (let i = 0; i < r.serviceMans.length; i++) {
            m = r.serviceMans[i]
            oMap[m.organizationName] = m.organizationName
            nMap[m.realName] = m.realName
            rMap[m.roleName] = m.roleName
          }
          r.organizationNamesOfServiceMen = Object.values(oMap).join("，")
          r.namesOfServiceMen = Object.values(nMap).join("，")
          r.roleNamesOfServiceMen = Object.values(rMap).join("，")
        }
        if (r.deviceLastMaintainTime) {
          r.deviceLastMaintainTime = moment(+r.deviceLastMaintainTime).format("YYYY-MM-DD HH:mm:ss")
        }
        if (r.registerTime) {
          r.registerTime = moment(+r.registerTime).format("YYYY-MM-DD HH:mm:ss")
        }
        if (r.createdAt) {
          r.createdAt = moment(+r.createdAt).format("YYYY-MM-DD HH:mm:ss")
        }
        if (r.percentage) {
          r.percentage = (r.percentage * 100).toFixed(0) + "%"
        }
        return r
      })

      this.warningPagination.total = total
      for (let key in this.warningTableHighlightInfo) {
        this.warningTableHighlightInfo[key] = this.warningTableQueryParams[key]
      }
      this.isWarningTableLoading = false
    },
    /* 预警表格跳转 */
    async goToDevice(r) {
      r.codeLoading = true
      this.warnings = [...this.warnings]

      const { success, data } = await this.requestDevice(r.device.id)
      if (success) {
        this.$store.commit("setDeviceInfo", data)
        r.codeLoading = false
        this.warnings = [...this.warnings]
        this.$router.push({
          path: "/equipment/list/submit/edit",
          query: {
            key: "monitor"
          }
        })
      } else {
        return this.$message.warning(this.$t("warning.noDevice"))
      }
    },
    goToCustomer(r) {
      this.$router.push({
        path: "/customer/detail",
        query: {
          id: r.customer?.id
        }
      })
    },
    goBack() {
      this.toggleComponent("WarningType", {}, [])
    },
    /* 事件 */
    async exportWarnings() {
      this.isExporting = true
      const { success, data } = await this.requestExportWarnings()
      if (success) {
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement("a")
        link.style.display = "none"
        link.href = url
        const timestamp = new Date().getTime()
        link.download = timestamp + ".xlsx"
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
        document.body.removeChild(link)
        this.$message.success(this.$t("messages.es"), 1)
      }
      this.isExporting = false
    },
    /* 预警表格事件 */
    handleWarningTableMultipieFilterParamsChange(field) {
      const m = this.warningTableMultipieFilterParams[field]

      if (m) {
        if (m.req && (m.value || m.value === 0)) {
          this.renderWarningTable(1)
        }
      }
    },
    showWarningRemindModal(r) {
      this.selectedDevice = r.device
      this.isWarningRemindModalVisible = true
    },
    showWarningOrderModal(r, f) {
      this.isWarningOrderModalVisible = true
      this.orderInfo = {
        deviceCode: r.device.code,
        warningType: this.currentWarningContentType.routeName,
        isEdit: !!f
      }
    },
    showWarningInfoDiaglog(r) {
      this.deviceCodeForWarningInfoDiaglog = r.deviceCode
      this.compnayForWarningInfoDiaglog = r.customerCompany
      this.deviceModelForWarningInfoDiaglog = r.deviceModel
      this.deviceNameForWarningInfoDiaglog = r.device.name
      this.customerForWarningInfoDiaglog = r.customerCompany
      this.customerIdForWarningInfoDiaglog = r.customer.id
      this.protocolCodeForWarningInfoDiaglog = r.device.protocolCode
      this.warningRecordForm.deviceId = r.device.id
      this.selectedWarningId = r.id
      this.warningTag = this.origin_warningTag = r.device.tag

      const date = new Date()
      this.warningHistoryEndTime = moment(+date)
      date.setMonth(date.getMonth() - 1)
      this.warningHistoryStartTime = moment(+date)

      this.isWarningInfoModalVisible = true

      this.handleWarningInfoModalCardTabChange(this.warningInfoModalCardTabList[0].key)
    },
    goToHistory(r) {
      this.$router.push({
        name: "history",
        params: {
          machineId: r.device.code,
          machineType: r.device.model,
          protocolCode: r.device.protocolCode,
          id: r.device.id
        }
      })
    },
    showConfirmToDeleteWarning(r) {
      this.$confirm({
        title: this.$t("messages.ctrwi"),
        content: this.$t("messages.ctrwic"),
        onOk: async () => {
          const { success, message } = await this.requestDeleteErrorRecord(r.id)
          if (success) {
            this.$message.success(message)
          }
        }
      })
    },
    /* 预警字段配置事件 */
    toggleFieldSettingsVisible() {
      this.isFieldSettingsVisible = !this.isFieldSettingsVisible
    },
    backToColumnsAndHide(w, i) {
      const item = w
      item.hide = true
      this.warningTableUnsortableColumns.splice(i, 1)
      this.warningTableColumns.unshift(item)
      this.saveFields()
    },
    saveFields() {
      const data = new FormData()
      const username = localStorage.getItem("username")
      const warningCode = this.currentWarningContentType.routeName
      if (username && warningCode) {
        data.append("username", username + "-" + warningCode)

        for (let i = 0; i < this.warningTableUnsortableColumns.length; i++) {
          data.append("fields", this.warningTableUnsortableColumns[i].dataIndex + "-fixed" )
        }

        let w
        for (let i = 0; i < this.warningTableColumns.length; i++) {
          w = this.warningTableColumns[i]
          if (w.hide) {
            data.append("fields", w.dataIndex + "-hide")
          } else {
            data.append("fields", w.dataIndex)
          }
        }
      }

      this.requestSaveFields(data)
    },
    backToColumns(w, i) {
      const item = w
      this.warningTableUnsortableColumns.splice(i, 1)
      this.warningTableColumns.unshift(item)
      this.saveFields()
    },
    handleDragEnd() {
      this.tableKey = !this.tableKey
      debounce(this.saveFields, 500)
    },
    toggleFieldHide(w) {
      w.hide = !w.hide
      this.tableKey = !this.tableKey
      this.saveFields()
    },
    toggleFixed(source, target, i) {
      const item = this[source][i]
      this[source].splice(i, 1)
      item.hide = false
      this[target].push(item)

      this.tableKey = !this.tableKey
      this.saveFields()
    },
    /* 其它预警对话框 */
    showWarningDetail(w) {
      this.isWarningRemindModalVisible = false
      this.setCurrentWarningContentType(w)
    },
    /* 预警工单对话框 */
    closeWarningOrderModal() {
      this.isWarningOrderModalVisible = false
    },
    changeWarningOrderModalLoading(v) {
      this.isWarningOrderModalLoading = v
    },
    /* 查看预警对话框 */
    clearWarningInfo() {
      this.deviceCodeForWarningInfoDiaglog = ""
      this.compnayForWarningInfoDiaglog = ""
      this.deviceModelForWarningInfoDiaglog = ""
      this.deviceNameForWarningInfoDiaglog = ""
      this.customerForWarningInfoDiaglog = ""
      this.protocolCodeForWarningInfoDiaglog = ""
      this.warningRecordForm.deviceId = ""
      this.selectedWarningId = ""
      this.warningTag = this.origin_warningTag = null

      this.isWarningHistoryTableLoading = false
      this.warningHistoryTableColumns = []
      this.warningHistories = []
      this.warningHistoryStartTime = null
      this.warningHistoryEndTime = null

      this.serviceList = []
      this.serviceTableQueryParams = {
        orderNum: "",
        serviceType: "",
        equipmentCode: "",
        equipmentName: "",
        equipmentModel: "",
        customer: "",
        servicehours: "",
        serviceContent: "",
        serviceman: "",
        updateman: ""
      }
      this.serviceTableHighlightInfo = {
        orderNum: "",
        serviceType: "",
        equipmentCode: "",
        equipmentName: "",
        equipmentModel: "",
        customer: "",
        servicehours: "",
        serviceContent: "",
        serviceman: "",
        updateman: ""
      }

      this.ignoreDate = null
      this.ignoreId = null
      this.warningRecords = []
    },
    async submitWarningInfo() {
      let flag = true, message
      this.isWarningInfoModalLoading = true

      const a = [], u = []
      let w, o
      for (let i = 0; i < this.warningRecords.length; i++) {
        w = this.warningRecords[i]
        o = {
          deviceId: this.warningRecordForm.deviceId,
          content: w.content
        }
        if (w.id) {
          o.id = w.id
          u.push(o)
        } else {
          a.push(o)
        }
      }

      if (a.length || u.length) {
        const { success, m } = await this.requestSubmitWarningNotes(a, u)
        flag = flag && success
        message = m || message
      }

      if (this.ignoreDate) {
        const now = new Date()
        const date = new Date(this.ignoreDate)
        date.setHours(now.getHours())
        date.setMinutes(now.getMinutes())
        date.setSeconds(now.getSeconds())
        let params = {
          deviceId: this.warningRecordForm.deviceId,
          warningCode: this.currentWarningContentType.routeName,
          expiredAt: +date
        }

        const { success, m } = await this.requestSubmitWarningIgnore(params)
        flag = flag && success
        message = m || message
      } else {
        if (this.ignoreId) {
          const { success, m } = await this.requestDeleteWarningIgnore(this.ignoreId)
          flag = flag && success
          message = m || message
        }
      }

      if (this.origin_warningTag !== this.warningTag) {
        const { success, m } = await this.requestChangeDeviceTag(this.warningRecordForm.deviceId)
        flag = flag && success
        message = m || message
      }

      if (flag) {
        this.$message.success(message)
        this.isWarningInfoModalVisible = false
        this.renderWarningTable()
      }

      this.isWarningInfoModalLoading = false
    },
    ignoreForever() {
      this.ignoreDate = new Date("2100-01-01")
    },
    handleWarningInfoModalCardTabChange(k) {
      this.activeWarningInfoModalCardTab = k
      this.renderWarningInfo()

      switch(k) {
        case "history":
          this.renderWarningHistoryTable()
          break
        case "service":
          this.renderServiceTable(1)
          break
        default:
          break
      }
    },
    /* 查看预警对话框_预警历史 */
    async renderWarningHistoryTable() {
      this.warningHistoryTableColumns = warningOptions.privateColumns[this.currentWarningContentType.routeName]

      this.isWarningHistoryTableLoading = true

      const data = await this.requestWarningHistories()
      this.warningHistories = data.map(d => {
        if (d.createdAt) {
          d.createdAt = moment(+d.createdAt).format("YYYY-MM-DD HH:mm:ss")
        }

        if (d.percentage) {
          d.percentage = d.percentage * 100 + "%"
        }

        if (d.registerTime) {
          d.registerTime = moment(+d.registerTime).format("YYYY-MM-DD HH:mm:ss")
        }

        return d
      })

      this.isWarningHistoryTableLoading = false
    },
    /* 查看预警对话框_服务档案 */
    showServiceModal(r) {
      if (r) {
        this.serviceModalTitle = this.$t("saleDocument.editTitle")
        this.selectedService = r
      } else {
        this.serviceModalTitle = this.$t("saleDocument.addTitle")
        this.selectedService = {
          equipmentId: this.warningRecordForm.deviceId,
          equipmentCode: this.deviceCodeForWarningInfoDiaglog,
          equipmentName: this.deviceNameForWarningInfoDiaglog,
          equipmentModel: this.deviceModelForWarningInfoDiaglog,
          customerId: this.customerIdForWarningInfoDiaglog,
          customer: this.customerForWarningInfoDiaglog,
          protocolCode: this.protocolCodeForWarningInfoDiaglog
        }
      }

      this.isServiceModalVisible = true
    },
    async setServiceTableSelectOptions() {
      const lang = this.lang === "en" ? "en-US" : "zh-CN"
      const data = await this.requestAfterSaleOrderStatus(lang)

      const orderStateMap = {}
      let d
      for (let i = 0; i < data.length; i++) {
        d = data[i]
        orderStateMap[d.value] = d.text
      }

      this.orderStateMap = orderStateMap
    },
    async renderServiceTable(p = this.servicePagination.current) {
      this.isServiceTableLoading = true
      this.servicePagination.current = p

      this.serviceTableQueryParams.equipmentCode = this.deviceCodeForWarningInfoDiaglog

      const { records, total } = await this.requestServiceList()
      this.serviceList = records
      this.servicePagination.total = total

      for (let k in this.serviceTableHighlightInfo) {
        this.serviceTableHighlightInfo[k] = this.serviceTableQueryParams[k]
      }

      this.isServiceTableLoading = false
    },
    async removeService(r) {
      r.loading = true
      this.serviceList = [...this.serviceList]

      const { success, message } = await this.requestDeleteService(r.id)
      if (success) {
        this.$message.success(message)
        this.renderServiceTable()
      }
    },
    /* 服务档案对话框 */
    closeServiceModal(f) {
      this.isServiceModalVisible = false

      if (f) {
        this.renderServiceTable(1)
      }
    },
    /* 查看预警对话框_预警记录 */
    setRowKey(_, i) {
      return i
    },
    async removeWarningRecord(r) {
      if (r.id) {
        const { success, message } = await this.requestDeleteWarningRecordNote(r.id)
        if (success) {
          this.$message.success(message)
          this.warningRecords.splice(r.index.at(-1) - 1, 1)
          this.warningRecords.forEach((n, i) => {
            n.index = this.$t("warning.record") + (i + 1)
          })
        }
      } else {
        this.warningRecords.splice(r.index.at(-1) - 1, 1)
        this.$message.success(this.$t("messages.success"))
      }
    },
    previewImg(i, list = this.srcList) {
      const imgList = list.map(s => s.path)
      this.$hevueImgPreview({
        multiple: true,
        nowImgIndex: i,
        imgList
      })
    },
    async renderWarningInfo() {
      this.isWarningRecordTableLoading = true
      
      const { ignoreWarnings, notes } = await this.requestWarningInfo(this.selectedWarningId, this.currentWarningContentType.routeName)

      if (ignoreWarnings.length) {
        const ignoreWarning = ignoreWarnings.find(i => i.warningCode === this.currentWarningContentType.routeName)
        if (ignoreWarning) {
          this.ignoreId = ignoreWarning.id
        }
      }
      
      this.ignoreDate = new Date()

      this.warningRecords = notes.map((n, i) => {
        n.index = this.$t("warning.record") + (i + 1)
        n.edit = false
        if (n.updatedAt) {
          n.updatedAt = moment(n.updatedAt).format("YYYY-MM-DD HH:mm:ss")
        }
        n.images = (n.attachments || []).map(a => ({ path: a.url, name: a.name }))
        return n
      })

      this.isWarningRecordTableLoading = false
    },
    handleWarningRecordTableMouseover(r, i) {
      r.images[i].isMaskShow = true
      r.images = [...r.images]
    },
    handleWarningRecordTableMouseleave(r, i) {
      r.images[i].isMaskShow = false
      r.images = [...r.images]
    },
    /* 预警记录对话框 */
    async showWarningRecordModal(r) {
      if (r) {
        this.warningRecordForm.id = r.id
        this.warningRecordForm.content = r.content
        this.srcList = [...r.images]
        this.fileList = []

        const promises = []
        for (let i = 0; i < this.srcList.length; i++) {
          promises.push(new Promise(async resolve => {
            const file = await this.turnURLToFile(this.srcList[i])
            if (file) {
              this.fileList.push(file)
              resolve()
            }
          }))
        }

        await Promise.all(promises)
      }

      this.isWarningRecordModalVisible = true
    },
    clearWarningRecordForm() {
      this.warningRecordForm.content = ""
      this.warningRecordForm.id = null
      this.fileList = []
      this.srcList = []
    },
    async submitWarningRecord() {
      this.isWarningRecordModalLoading = true

      let data = new FormData()
      data.append("content", this.warningRecordForm.content)
      data.append("deviceId", this.warningRecordForm.deviceId)

      for (let i = 0; i < this.fileList.length; i++) {
        data.append("images", this.fileList[i])
      }

      const { success, message } = await this.requestSubmitWarningRecord(data)
      if (success) {
        this.$message.success(message)
        this.isWarningRecordModalVisible = false
        this.renderWarningInfo()
      }

      this.isWarningRecordModalLoading = false
    },
    onBeforeUpload(file) {
      let acceptTypes

      acceptTypes = [
        "image/jpg",
        "image/jpeg",
        "image/png",
        "video/mp4",
        "video/webm"
      ]

      if (file.size > 1024 * 1024 * 500) {
        // 文件大于 30M 时取消上传
        ElNotification({
          type: "error",
          message: this.$t("messages.lessThan500MB")
        })
        return false
      }
      if (!acceptTypes.includes(file.type)) {
        // 继续上传
        ElNotification({
          type: "error",
          message: this.$t("messages.rightFile")
        })

        return false // 停止上传
      }
      return true
    },
    hadnleFileChange(e) {
      let i
      for (i = 0; i < e.target.files.length; i++) {
        if (!this.onBeforeUpload(e.target.files[i])) {
          break
        }
      }
      if (i == e.target.files.length) {
        this.fileList = this.fileList.concat(Array.from(e.target.files))
        this.srcList = this.fileList.map(f => {
          if (f.id) {
            return f
          } else {
            return {
              path: "",
              isMaskShow: false
            }
          }
        })
        this.fileList.forEach((f, i) => {
          if (!f.id) {
            const fr = new FileReader()
            fr.readAsDataURL(f)
            fr.onload = e => {
              this.srcList[i] = {
                path: "data:image/png;base64," + e.target.result.substring(e.target.result.indexOf(",") + 1),
                isMaskShow: false
              }
              this.$forceUpdate()
            }
          }
        })
      }
    },
    rF(i) {
      this.$Mconfirm(this.$t("messages.ctrp"), this.$t("messages.hint"), {
        confirmButtonText: this.$t("common.okText"),
        cancelButtonText: this.$t("common.cancelText"),
        type: "warning"
      })
      .then(() => {
        if (this.fileList[i].id) {
          this.delField.push(this.fileList[i].id)
        }
        const arr = [...this.fileList]
        arr.splice(i, 1)
        this.srcList.splice(i, 1)
        this.fileList = arr
        this.$forceUpdate()
        this.$EM({
          type: "success",
          message: this.$t("messages.rs")
        })
        return true
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: this.$t("messages.cr")
        })
      })
    },
    showFileModal() {
      this.$refs.InputFileDOm.click()
    },
    /* 请求 */
    async requestFields() {
      let result = null

      try {
        const username = localStorage.getItem("username")
        const warningCode = this.currentWarningContentType.routeName

        if (username && warningCode) {
          const { data } = await getFields(username + "-" + warningCode)
          result = data
        }

        return result
      } catch(e) {
        console.log(e)
        return result
      }
    },
    async requestWarningList() {
      try {
        const { data } = await getWarningList(
          {
            current: this.warningPagination.current,
            pageSize: this.warningPagination.pageSize,
            latest: true,
            type: this.currentWarningContentType.routeName
          },
          this.setWarningTableSearchParams()
        )
        return data
      } catch(e) {
        console.log(e)
        return {
          records: [],
          total: 0
        }
      }
    },
    async requestExportWarnings() {
      try {
        const { data } = await exportWarningList({
          latest: true,
          type: this.currentWarningContentType.routeName,
          lang: "zh-CN"
        }, this.setWarningTableSearchParams())

        return {
          success: true,
          data
        }
      } catch(e) {
        console.log(e)
        return {
          success: false
        }
      }
    },
    async requestWarningStatuses(lang) {
      try {
        const { data } = await getDict(lang, "warningStatus")

        return data.content
      } catch(e) {
        console.log(e)
        return []
      }
    },
    async requestWarningTags(lang) {
      try {
        const { data } = await getDict(lang, "WarningTag")

        return data.content
      } catch(e) {
        console.log(e)
        return []
      }
    },
    async requestSaveFields(data) {
      try {
        await postFields(data)
      } catch(e) {
        console.log(e)
      }
    },
    async requestDevice(id) {
      let success = false, d = {}

      try {
        const { data } = await searchDeviceList(1, 10, {
          query: [],
          filter: [
            {
              field: "id",
              value: id
            }
          ]
        })
        
        if (data.total) {
          success = true
          d= data.records[0]
          d.status = (d.status || "").split(",")
        } else {
          success = false
        }
      } catch(e) {
        success = false
      }

      return { success, data: d }
    },
    async requestWarningHistories() {
      if (!(this.warningHistoryStartTime && this.warningHistoryEndTime)) {
        this.$message.warning(this.$t("placeholder.timeRange"))
        return []
      }

      const warningType = this.currentWarningContentType.routeName
      try {
        const { data } = await getWarningHistory({
          startTime: +this.warningHistoryStartTime._d,
          endTime: +this.warningHistoryEndTime._d,
          deviceCode: this.deviceCodeForWarningInfoDiaglog,
          warningType
        })
        if (data && data[warningType]?.length) {
          return data[warningType]
        } else {
          return []
        }
      } catch(e) {
        console.log(e)
        return []
      }
    },
    async requestServiceList() {
      try {
        const { data } = await getList(
          this.servicePagination.current,
          this.servicePagination.pageSize,
          this.serviceTableQueryParams
        )

        return data
      } catch(e) {
        console.log(e)

        return {
          records: [],
          total: 0
        }
      }
    },
    async requestDeleteService(id) {
      try {
        const { message } = await removeS(id)
        return {
          success: true,
          message
        }
      } catch(e) {
        console.log(e)
        return {
          success: false
        }
      }
    },
    async requestAfterSaleOrderStatus(lang) {
      try {
        const { data } = await getDict(lang, "afterSaleOrderStatus")
        return data.content
      } catch(e) {
        console.log(e)
        return []
      }
    },
    async turnURLToFile(s) {
      try {
        const response = await fetch(
          process.env.NODE_ENV === "development"
            ? ("pic/" + s.name)
            : s.path
        )
        const blob = await response.blob()
        const file = new File([blob], s.name, { type: blob.type })
        return file
      } catch(e) {
        console.log(e)
        return null
      }
    },
    async requestDeleteWarningRecordNote(id) {
      try {
        const { message } = await deleteWarningRecordNote(id)
        return {
          success: true,
          message
        }
      } catch(e) {
        console.log(e)
        return {
          success: false
        }
      }
    },
    async requestSubmitWarningRecord(data) {
      let success = false, message
      try {
        if (this.warningRecordForm.id) {
          data.append("id", this.warningRecordForm.id)
          const { message: m } = await updateWarningRecord(data)
          message = m
        } else {
          const { message: m } = await addWarningRecord(data)
          message = m
        }
        success = true

        return {
          success,
          message
        }
      } catch(e) {
        console.log(e)
        success = false
        return {
          success
        }
      }
    },
    async requestWarningInfo(id, type) {
      try {
        const { data } = await getWarningInfo({
          id,
          type
        })

        return { ...data, ignoreWarnings: data.ignoreWarnings || [] }
      } catch(e) {
        console.log(e)
        return {
          notes: [],
          ignoreWarnings: []
        }
      }
    },
    async requestSubmitWarningNotes(a, u) {
      let success = true, m

      try {
        const { message } = await addWarningNote(a)
        m = message
        success = true
      } catch(e) {
        console.log(e)
        success = false
        m = ""
      }

      try {
        const { message } = await updateWarningNote(u)
        m = message
      } catch(e) {
        console.log(e)
        success = false
        m = ""
      }

      return {
        success,
        m
      }
    },
    async requestSubmitWarningIgnore(params) {
      let success = false, m

      try {
        if (this.ignoreId) {
          const { message } = await updateWarningIgnore([params])
          success = true, m = message
        } else {
          const { message } = await addWarningIgnore([params])
          success = true, m = message
        }
      } catch(e) {
        console.log(e)
        success = false
        m = ""
      }

      return {
        success,
        m
      }
    },
    async requestDeleteWarningIgnore(id) {
      try {
        const { message } = await deleteWarningIgnore(id)
        return {
          success: true,
          m: message
        }
      } catch(e) {
        console.log(e)
        return {
          success: false
        }
      }
    },
    async requestChangeDeviceTag(id) {
      let success = false, m

      try {
        const { data } = await searchDeviceList(1, 10, {
          query: [],
          filter: [
            {
              field: "id",
              value: id
            }
          ],
          sort: []
        })

        if (data.total) {
          const device = data.records[0]

          const deviceForm = {
            id: device.id,
            code: device.code,
            name: device.name,
            type: device.type,
            status: device.status,
            deviceAddress: device.deviceAddress.length < 2 ? "0" + device.deviceAddress : device.deviceAddress,
            model: device.model,
            brand: device.brand,
            customerId: device.customerId,
            installAddress: device.installAddress,
            driverType: device.driverType,
            protocolCode: device.protocolCode,
            measurement: device.measurement,
            dtuCode: device.dtuCode,
            remark: device.remark,
            isStationDevice: device.isStationDevice,
            initialValue: device.initialValue,
            power: device.power,
            pressure: device.pressure,
            warrantyPeriod: device.warrantyPeriod,
            intervalTime: device.intervalTime,
            enabled: device.enabled,
            businessType: device.businessType,
            startTime: device.statrtTime,
            endTime: device.endTime,
            tag: this.warningTag || null
          }
          const { message } = await updateDevice(deviceForm)
          m = message
        }

        success = true
      } catch(e) {
        console.log(e)
        success = false
        m = ""

        return {
          success,
          m
        }
      }
    },
    async requestDeleteErrorRecord(id) {
      try {
        const { message } = await deleteErrorRecord(id)
        return {
          success: true,
          message
        }
      } catch(e) {
        console.log(e)
        return {
          success: false
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.warning_table {
  width: 100%;
  height: 100%;
  padding: 20px;

  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .content {
    position: relative;
    min-height: 560px;

    .tableHeader {
      color: rgba(0, 0, 0, .85);
      font-weight: 500;
      text-align: left;
  
      .ant-select {
        width: 100%;
      }
    }
  
    .dropdown-container {
      position: absolute;
      top: 30px;
      right: 70px;
      z-index: 10;

      .ant-dropdown-menu {
        position: absolute;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
      }
  
      .dropdown {
        margin-top: 10px;
      }
    }

    .ant-dropdown-menu-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: default;

      &.disabled {
        // background-color: #eee;
        color: rgba(100, 100, 100, 0.65);

        path {
          fill: rgba(100, 100, 100, 0.65);
        }

        .pre_icon {
          cursor: not-allowed;
        }
      }

      &:hover {
        background-color: #fff;
      }

      .pre_icon {
        color: rgba(0, 0, 0, 0.65);
        cursor: move;
      }

      .aft_icons {
        display: flex;
        align-items: center;

        .icon {
          color: rgba(0, 0, 0, 0.65);
          cursor: pointer;
        }
      }
    }
  }
}

/deep/ .el-table .table_highlight td {
  background-color: #e6f7ff !important;
}

/deep/ .ant-select-selection-selected-value {
  font-weight: normal !important;
}

/deep/ .el-table__empty-block {
  width: 100% !important;
  position: sticky;
  left: 0;
}

/deep/ .ant-btn-link {
  white-space: wrap;
  text-align: left;
}

.history_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-upload-list__item {
  display: flex;
  justify-content: space-between;
}

.upload-item {
  display: flex;
  width: 60%;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}

input.file {
  display: none;
}
</style>